// src/pages/personal/settings/PromotionsDiscountsSection/PurchaseBonus.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ShoppingCart } from 'lucide-react';
import { TEXT_STYLES } from '@/theme/typography';
import { COMPONENT_STYLES } from '@/theme/components';
import { COLORS } from '@/theme/colors';
import useBusinessCurrency from '@/hooks/useBusinessCurrency';
import { Card, Flex, Grid } from '@/components/ui/Layout';
import { useResponsive } from '@/hooks/useResponsive';

interface PurchaseBonusProps {
  purchaseBonus: {
    type: 'percentage' | 'fixed_amount';
    value: number;
  };
  onChange: (data: any) => void;
}

const PurchaseBonus: React.FC<PurchaseBonusProps> = ({ purchaseBonus, onChange }) => {
  // ИСПРАВЛЕНО: Указываем используемые пространства имен
  const { t } = useTranslation(['promotions', 'common']);
  const { currencySymbol } = useBusinessCurrency();
  const { isMobile } = useResponsive();
  
  // Обработчик изменения типа бонуса
  const handleTypeChange = (type: 'percentage' | 'fixed_amount') => {
    onChange({
      ...purchaseBonus,
      type
    });
  };

  // Обработчик изменения значения бонуса
  const handleValueChange = (value: number) => {
    onChange({
      ...purchaseBonus,
      value
    });
  };

  return (
    <Card 
      padding={isMobile ? "sm" : "md"} 
      className="border border-gray-200"
    >
      <Flex align="center" gap="xs" className="mb-4">
        <ShoppingCart className={`w-5 h-5 text-primary`} />
        <h3 className={TEXT_STYLES.h3}>{t('promotions:promotions.purchase_bonus')}</h3>
      </Flex>
      
      <p className={`mb-4 text-sm text-[${COLORS.secondary}]`}>
        {t('promotions:promotions.purchase_bonus_description')}
      </p>
      
      <Grid 
        cols={isMobile ? 1 : 2} 
        gap="md"
        mobileCols={1}
      >
        <div>
          <label className={COMPONENT_STYLES.form.label}>
            {t('promotions:promotions.bonus_type')}
          </label>
          <select
            value={purchaseBonus.type}
            onChange={(e) => handleTypeChange(e.target.value as 'percentage' | 'fixed_amount')}
            className={COMPONENT_STYLES.form.input}
          >
            <option value="percentage">{t('promotions:promotions.percentage')}</option>
            <option value="fixed_amount">{t('promotions:promotions.fixed_amount')}</option>
          </select>
        </div>
        
        <div>
          <label className={COMPONENT_STYLES.form.label}>
            {t('promotions:promotions.bonus_value')}
          </label>
          <Flex align="center">
            <input
              type="number"
              min="0"
              value={purchaseBonus.value}
              onChange={(e) => handleValueChange(parseFloat(e.target.value))}
              className={COMPONENT_STYLES.form.input}
            />
            <span className="ml-2">
              {purchaseBonus.type === 'percentage' ? '%' : currencySymbol}
            </span>
          </Flex>
        </div>
      </Grid>
    </Card>
  );
};

export default PurchaseBonus;